import { t } from "i18next";

export enum NotificationType {
    LicenseGranted = 'LicenseGranted',
    LicenseExpiringSoon = 'LicenseExpiringSoon',
    CourseContentPublished = 'CourseContentPublished',
    AttendanceMarkedAbsent = 'AttendanceMarkedAbsent',
}

export const getNotificationTypeLabels = () => ({
    [NotificationType.LicenseGranted]: t('notifications.typeLabels.licenseGranted'),
    [NotificationType.LicenseExpiringSoon]: t('notifications.typeLabels.licenseExpiringSoon'),
    [NotificationType.CourseContentPublished]: t('notifications.typeLabels.courseContentPublished'),
    [NotificationType.AttendanceMarkedAbsent]: t('notifications.typeLabels.attendanceMarkedAbsent'),
});

export const getNotificationTypeLabel = (notificationType: NotificationType): string => {
    const labels = getNotificationTypeLabels();
    return labels[notificationType];
};
